import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as award from '../award'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: award.RESOURCE.payload.dimension.partialId,
      partialId: award.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'TODO',
    isOptional: true,
    name: 'Federal Award Number',
    partialId: PartialId.Standard.create('fan'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
